/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { APP_BASE_HREF } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { CoreModule } from './@core/core.module';
import { NbEmailPassAuthProvider, NbAuthModule, NbAuthService } from '@nebular/auth';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { ThemeModule } from './@theme/theme.module';
import { NgbAlertModule, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { AuthGuard } from './auth-guard.service';
import { NgxPaginationModule } from 'ngx-pagination';
import { environment } from '../environments/environment';
import { NbCustomLoginComponent } from './pages/login/custom-login.component';
import { NbCustomLogoutComponent } from './pages/logout/custom-logout.component';

 
@NgModule({
  declarations: [AppComponent, NbCustomLoginComponent,NbCustomLogoutComponent],  
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    AppRoutingModule,
    NgxPaginationModule,
    NgbAlertModule,
    
    NgbModule.forRoot(),
    ThemeModule.forRoot(),
    CoreModule.forRoot(),
    NbAuthModule.forRoot({
     providers: {
       username: {
         service: NbEmailPassAuthProvider,
         config: {
           baseEndpoint: environment.baseUrl + '/app',
           login: {
             endpoint: '/account/login',
             method: 'post',
           },
           
         token: {
              key: 'id_token', 
              storageKey: 'auth_app_token',             
            },
           logout: {
              endpoint: '/account/login',
              method: 'post',
            },
            validation: {
              username: {
                required: true,
                regexp: "^[a-zA-Z0-9_-]+$"
              }
            }
         }
       },
     },
     forms: {
        login: {
          validation: {
                username: { 
                  required: true,
                  minLength: 3 
                }, 
                password: { 
                  required: true,
                  minLength: 8
                }  
          },
          redirectDelay: 500,
          strategy: 'username',
          rememberMe: true,
          showMessages: {
            success: true,
            error: true,
          },
          socialLinks: [], // Add social links if you use them
        },
      },
   }),
  ],
  bootstrap: [AppComponent],
  providers: [ { provide: APP_BASE_HREF, useValue: '/' },
    AuthGuard,
  ],
})
export class AppModule {
}



// WEBPACK FOOTER //
// ./src/app/app.module.ts